import { defineComponent as _defineComponent } from 'vue'
import { Organization } from '@/modules/Organizations/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSettingsSocials',
  props: {
    org: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})